/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-array-index-key */
/* eslint-disable indent */
import _ from 'lodash';
import { getMaxWidthFromStrArray } from 'utils/functionsWithArray';
import { Col, Row } from 'antd';
import { QuestionComponentProps } from '../../type';
import { HeaderCommon, QuestionNumber, QuestionText } from '../RenderCommon';
import './styles.scss';

const FillInTheBlank = ({ questionData, questionIndex, isCombineChild }: QuestionComponentProps) => {
  const { questionText, answers, imageUrl } = questionData;
  const optionType = questionData.optionType.toUpperCase();
  const answerArr = Array.isArray(answers)
    ? answers.map((i) => {
        const ans = i.answer.split('|');
        // Lấy đáp án dài nhất
        const choose = _.maxBy(ans, (o: string) => o.length);
        return choose;
      })
    : [];

  const maxWidthAnswers = getMaxWidthFromStrArray(answerArr, '20px');

  const HintBox = () => {
    const words = Array.isArray(answers) ? answers.map((item) => item.answer) : [];
    return (
      <div className='flex_row_center tw-mb-4'>
        <div className='word_box'>
          {words.map((item, index) => (
            <span key={index} style={{ marginRight: words[index + 1] ? 30 : 0 }}>
              {item}
            </span>
          ))}
        </div>
      </div>
    );
  };

  const renderQuestion = () => {
    if (!questionText) return null;

    // Replace <p> tags with <div> to prevent external CSS issues
    let sanitizedHtml = questionText.replaceAll('<p', '<div').replaceAll('</p>', '</div>');

    // Replace sequences of 3 or more underscores with styled <span>
    const underlineRegex = /_{3,}/g;
    sanitizedHtml = sanitizedHtml.replace(underlineRegex, `<span style="display: inline-block; height: 1rem; width: ${maxWidthAnswers}px; border-bottom: 1px dotted black; padding: 0px 5px;"></span>`);
    return <QuestionText key={questionIndex} questionText={sanitizedHtml} />;
  };
  const RenderLayout = () => {
    switch (optionType) {
      case 'FILLINTHEBLANK_LOOKANREADYES/NO':
        return (
          <Row gutter={24} align='middle'>
            {imageUrl ? (
              <Col className='tw-mb-4'>
                <img src={imageUrl} style={{ width: 'min(100%, max(60%, 600px)', height: 'auto', maxHeight: '60vh', objectFit: 'contain' }} />
              </Col>
            ) : null}

            <Col className='tw-mb-4'>
              <QuestionNumber isCombineChild={isCombineChild} questionIndex={questionIndex} />
              {renderQuestion()}
            </Col>
          </Row>
        );

      default:
        return (
          <div>
            <div className='flex_row_center tw-mb-4'>{questionData.imageUrl ? <img src={questionData.imageUrl} style={{ width: 'min(100%, max(60%, 600px)', height: 'auto', maxHeight: '60vh', objectFit: 'contain' }} /> : null}</div>
            {optionType === 'FILLINTHEBLANK_CHOOSEWORD' ? <HintBox /> : null}
            <div className='tw-mb-4'>
              <QuestionNumber isCombineChild={isCombineChild} questionIndex={questionIndex} />
              {renderQuestion()}
            </div>
          </div>
        );
    }
  };

  return (
    <div className='fill_in_the_blank_print' style={{ marginLeft: isCombineChild ? 5 : 0 }}>
      <HeaderCommon key={`fill-in-the-blank-${questionData.id}`} questionIndex={questionIndex} questionData={questionData} isCombineChild={isCombineChild} />
      <RenderLayout />
    </div>
  );
};

export default FillInTheBlank;
